$(document).ready(function () {
    $('[data-manual-cancel]').click(function (e) {
        e.preventDefault();
        $button = $(this);
        $.confirm({
            title: $button.attr('data-cn-title'),
            content: $button.attr('data-cn-content'),
            buttons: {
                cancel: {
                    text: $button.attr('data-cn-no'),
                    btnClass: 'mxm_button btn btn-link'
                },
                confirm: {
                    text: $button.attr('data-cn-yes'),
                    btnClass: 'mxm_button btn btn-primary',
                    action: function () {
                        $.dialog({
                            title: $button.attr('data-cn-title'),
                            content: "",
                            icon: 'fal fa-spinner fa-spin',
                        });
                        $.ajax({
                            data: { 'bid': $button.attr('data-manual-cancel') },
                            type: 'post',
                            url: $button.attr('data-action-url'),
                            beforeSend: function (xhr) {
                                var nonce = $('body').data('rest-nonce');
                                if (nonce && nonce.length) {
                                    xhr.setRequestHeader('X-WP-Nonce', nonce);
                                }
                            }
                        }).done(function (result) {
                            location.reload();
                        }).fail(function (result) {
                            console.warn(result);
                        });

                    },
                }
            }
        });
    });
    $('.acf-form-submit').append($('[data-manual-cancel]'));
    $('[data-manual-cancel]').removeClass('hide');
});